import { render, staticRenderFns } from "./washingFacilityPlanDoc.vue?vue&type=template&id=073b3a64"
import script from "./washingFacilityPlanDoc.vue?vue&type=script&lang=js"
export * from "./washingFacilityPlanDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('073b3a64')) {
      api.createRecord('073b3a64', component.options)
    } else {
      api.reload('073b3a64', component.options)
    }
    module.hot.accept("./washingFacilityPlanDoc.vue?vue&type=template&id=073b3a64", function () {
      api.rerender('073b3a64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/psi/lbe/wfp/washingFacilityPlanDoc.vue"
export default component.exports